import { useRef, useState } from "react";
import LessonLayout from "../../layouts/Lesson.layout";
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Box,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import Header from "./sections/Module.Header";
import ModuleBody from "./sections/Module.Content";

import { Fallback } from "../../components/wrappers/WithSuspense";
import { useConsumeModule } from "./api";
import { useAppSelector } from "../../store";
import { ModuleType } from "../../internal/courses/api";
import ModulePractice from "./sections/Module.Practice";

export enum EventType {
  VIEW = "view",
  ATTEMPT = "attempt",
  COMPLETE = "complete",
  HINT_VIEWED = "hint_viewed",
  EXPLANATION_VIEWED = "explanation_viewed",
  ANSWER_REVEALED = "answer_revealed",
  START_LESSON = "start_lesson",
  LESSON_COMPLETE = "lesson_complete",
  REVIEW_COMPLETED = "review_complete",
}

const Module = () => {
  const { moduleId = "", courseId = "" } = useParams();
  const [isOpenDrawer, setOpenDrawer] = useState(false);
  const { revealIndex, progress } = useAppSelector((s) => s.content);
  const btnRef = useRef<any>();
  const { data, isLoading, isFetching } = useConsumeModule(moduleId);

  if (isLoading || isFetching) {
    return <Fallback />;
  }

  if ((!moduleId && !courseId) || !data) {
    // todo: add the page not found
    return <h1>invalid page </h1>;
  }
  const getProgress = () => {
    if (data.type === ModuleType.content) {
      return (
        ((revealIndex + 1) / (data.lessons[0] as ILesson).content.length) * 100
      );
    } else {
      return (progress / (data.practices[0] as IPractice).content.length) * 100;
    }
  };

  return (
    <Box>
      <LessonLayout
        Header={
          <Header
            {...{
              title: data.title,
              progress: getProgress(),
            }}
          />
        }
        Body={
          data.type === ModuleType.content ? (
            <ModuleBody
              lessonId={(data.lessons[0] as ILesson)._id}
              progress={data.progress}
              content={(data.lessons[0] as ILesson).content}
            />
          ) : (
            <ModulePractice
              practiceId={(data.practices[0] as IPractice)._id}
              progress={data.progress}
              content={(data.practices[0] as IPractice).content}
            />
          )
        }
      />
      <Drawer
        isOpen={isOpenDrawer}
        placement={"top"}
        onClose={() => setOpenDrawer(false)}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          {/* <DrawerHeader>{data.data?.title}</DrawerHeader> */}

          <DrawerBody mb={"1rem"}>
            {/* <TopicInfo
              currentGroupId={currentGroupId}
              contentGroups={data.data.contentGroups}
              onClick={(id) => {
                setOpenDrawer(false);
              }}
            /> */}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default Module;
